






















import Vue from "vue";
import Component from "vue-class-component";
import { Getter } from "vuex-class";
import { rootGetterNames } from "@/store";
import { ROUTE_NAMES } from "@/router/routenames";

@Component
export default class AppNavDrawer extends Vue {
  @Getter(rootGetterNames.getDrawerState) drawer;

  items = [
    {
      title: "Dashboard",
      icon: "mdi-home",
      localizationString: "routeDescriptions.dashboard",

      route: ROUTE_NAMES.DASHBOARD
    },
    {
      icon: "mdi-chart-bar",
      localizationString: "routeDescriptions.measures",
      route: ROUTE_NAMES.MEASURES
    },
    {
      icon: "mdi-chart-bar",
      localizationString: "routeDescriptions.averageProcessingTime",
      route: ROUTE_NAMES.AVERAGE_PROCESSING_TIME
    },
    {
      icon: "mdi-chart-pie",
      localizationString: "routeDescriptions.findingTypes",
      route: ROUTE_NAMES.FINDING_TYPES
    },
    {
      icon: "mdi-chart-pie",
      localizationString: "routeDescriptions.measureTypes",
      route: ROUTE_NAMES.MEASURE_TYPES
    },
    {
      icon: "mdi-clock",
      localizationString: "routeDescriptions.measuresDueDate",
      route: ROUTE_NAMES.MEASURES_DUE_DATE
    }
  ];
}
